export const about = [
    {id:1,label:"Technical Skills",text:"Strong foundation in HTML, CSS, and JavaScript."},
    {id:2,label:"Passion",text:"A keen interest in UI/UX principles to blend functionality with aesthetics."},
    {id:3,label:"Continuous Learning",text:"Committed to staying updated on the latest web technologies and best practices."},
    {id:4,label:"Interests",text:"Enjoys exploring new frameworks and contributing to open-source projects to refine skills and expand knowledge."}
];

export const langIcons = [
    {id:1,img:"/img/about/ab1.png",alt:"icon 1"},
    {id:2,img:"/img/about/ab2.png",alt:"icon 2"},
    {id:3,img:"/img/about/ab3.png",alt:"icon 3"},
    {id:4,img:"/img/about/ab4.png",alt:"icon 4"}
];

export const services = [
    {id:1,img:"/img/services/s1.png",label:"Responsive Web Design",text:"I create visually appealing and responsive websites that adapt seamlessly to various screen sizes, ensuring an optimal user experience on desktops, tablets, and mobile devices."},
    {id:2,img:"/img/services/s2.png",label:"Custom Web Development",text:"I build tailored websites that reflect your brand's identity and meet your specific needs, using the latest technologies to ensure functionality and style."},
    {id:3,img:"/img/services/s3.png",label:"Front-End Development",text:"I leverage HTML, CSS, and JavaScript to build responsive and interactive web applications, ensuring that users have a seamless experience across all devices."},
    {id:4,img:"/img/services/s4.png",label:"JavaScript Development",text:"Using modern frameworks like React, I build dynamic and interactive web applications that provide users with rich and engaging experiences, all while maintaining high performance."}
];

export const contacts = [
    {
      id: 1,
      icon: "fa fa-envelope",
      txt: "asmaa7cu@gmail.com",
      label: "Email",
    },
    { id: 2, icon: "fa fa-phone", txt: "01xxxxxxxx", label: "Phone" },
    {
      id: 3,
      icon: "fa fa-behance",
      txt: "behance.net/asmaa",
      label: "Behance",
      to: "https://www.behance.net/asmaasaad7",
    },
    {
      id: 4,
      icon: "fa fa-github",
      txt: "github.com/asmaa",
      label: "Github",
      to: "https://github.com/Asmaa2796",
    },
  ];